"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = sendTimeout;

var _setSendTimeout = require("../actions/setSendTimeout");

var DEFAULT_STATE = 20000;

function sendTimeout() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      payload = _ref.payload,
      type = _ref.type;

  switch (type) {
    case _setSendTimeout.SET_SEND_TIMEOUT:
      state = payload.sendTimeout;
      break;

    default:
      break;
  }

  return state;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJERUZBVUxUX1NUQVRFIiwic2VuZFRpbWVvdXQiLCJzdGF0ZSIsInBheWxvYWQiLCJ0eXBlIiwiU0VUX1NFTkRfVElNRU9VVCJdLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZWR1Y2Vycy9zZW5kVGltZW91dC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBTRVRfU0VORF9USU1FT1VUIH0gZnJvbSAnLi4vYWN0aW9ucy9zZXRTZW5kVGltZW91dCc7XG5cbmNvbnN0IERFRkFVTFRfU1RBVEUgPSAyMDAwMDtcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2VuZFRpbWVvdXQoc3RhdGUgPSBERUZBVUxUX1NUQVRFLCB7IHBheWxvYWQsIHR5cGUgfSkge1xuICBzd2l0Y2ggKHR5cGUpIHtcbiAgICBjYXNlIFNFVF9TRU5EX1RJTUVPVVQ6XG4gICAgICBzdGF0ZSA9IHBheWxvYWQuc2VuZFRpbWVvdXQ7XG4gICAgICBicmVhaztcblxuICAgIGRlZmF1bHQ6XG4gICAgICBicmVhaztcbiAgfVxuXG4gIHJldHVybiBzdGF0ZTtcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUVBLElBQU1BLGFBQWEsR0FBRyxLQUF0Qjs7QUFFZSxTQUFTQyxXQUFULEdBQStEO0VBQUEsSUFBMUNDLEtBQTBDLHVFQUFsQ0YsYUFBa0M7O0VBQUE7RUFBQSxJQUFqQkcsT0FBaUIsUUFBakJBLE9BQWlCO0VBQUEsSUFBUkMsSUFBUSxRQUFSQSxJQUFROztFQUM1RSxRQUFRQSxJQUFSO0lBQ0UsS0FBS0MsZ0NBQUw7TUFDRUgsS0FBSyxHQUFHQyxPQUFPLENBQUNGLFdBQWhCO01BQ0E7O0lBRUY7TUFDRTtFQU5KOztFQVNBLE9BQU9DLEtBQVA7QUFDRCJ9